<style scoped>
.imageDiv {
  width: 50px !important;
  height: 40px;
}
.blockTitle {
  position: relative;
}
.imageDiv img {
  max-width: 40px;
  max-height: 40px;
  position: absolute;
  transition: all 0.4s ease;
  padding: 0px;
}
img.imgexpanded {
  max-height: 120px !important;
  /* max-height: 100px !important; */
  max-width: 120px !important;
  background: white;
  box-shadow: 0px 0px 4px #bbbbbb;
  border-radius: 60px;
  margin-top: -8px;
  margin-left: -8px;
  /* padding: 10px; */
  opacity: 0.95;
}
</style>
<template>
  <div class="blockTitle clearfix">
    <div
      class="imageDiv pull-left"
      v-if="
        message.user_type == 6 ||
        message.user_type == 7 ||
        message.message_tag == 'chat'
      "
      :class="{ expanded: expanded == message.id }"
    >
      <img
        @click.stop="toggleExpand"
        :src="message.parent_photo"
        class="pull-left img-circle profilepic"
        :class="expanded ? 'imgexpanded' : ''"
      />
    </div>
    <div class="rightSide pull-right">
      <span class="timeAgo">
        <timeago :datetime="message.created_timestamp * 1000"></timeago>
      </span>
      <span
        v-if="message.user_id != $root.user_id && !noHiding"
        class="far fa-trash-alt closeNotice"
        @click.stop="hideNotice()"
      ></span>
      <span
        v-if="message.user_id == $root.user_id"
        class="fas fa-pencil-alt closeNotice"
        @click.stop="showNewEditPostModal()"
      ></span>
    </div>
    <div
      class="imageDiv pull-left"
      v-if="
        message.user_type === 3 ||
        message.user_type === 21 ||
        message.user_type === 22
      "
    >
      <img
        v-if="message.user_type === 3"
        @click.stop="toggleExpand"
        :class="expanded ? 'imgexpanded' : ''"
        class="pull-left"
        :src="message.imageUrl"
      />
      <img
        v-if="message.user_type != 3"
        @click.stop="toggleExpand"
        :class="expanded ? 'imgexpanded' : ''"
        class="pull-left img-circle"
        :src="message.imageUrl"
      />
    </div>

    <span class="typeicon pull-left">
      <i
        v-if="message.typeIcon"
        class="fas"
        :class="'fa-' + message.typeIcon"
      ></i>
      <img
        class="adminLogo"
        v-if="message.user_type == 5"
        src="https://s3-eu-west-1.amazonaws.com/home-run/other/logo_small.png"
      />
    </span>
    <div class="middle">
      <span
        class="name colorNavy"
        v-if="message.user_type != 8 && message.user_type != 9"
        >{{ message.from_label || message.name || "" }}</span
      >
      <span class="safeguardTitle" v-if="message.type === 'bg_journey'"
        >Safeguarding active</span
      >
      <span
        class="name colorNavy"
        v-if="message.user_type == 8 || message.user_type == 9"
        >{{ message.salutation + " " + message.last_name || "" }}</span
      >
      <span
        v-if="message.important"
        style="display: inline-block; padding-left: 5px"
      >
        <i class="fas fa-star colorTrump"></i>
      </span>
      <span v-if="message.is_new" class="newLabel colorTrump"> NEW</span>
      <br />
      <span
        class="typelabel"
        v-if="message.typeLabel"
        style="display: inline-block"
      >
        {{ message.typeLabel }}
      </span>
      <span class="typelabel" v-if="message.message_tag === 'chat'">
        {{ message.is_staff ? "Private Chat from School" : "Private Chat" }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "blockTitle",
  props: {
    message: Object,
    noHiding: String,
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    hideNotice() {
      this.$emit("noticeEvent", "hideNotice");
    },
    showNewEditPostModal() {
      this.$emit("noticeEvent", "editNotice");
    },
  },
};
</script>
